import React from 'react'
import PropTypes from 'prop-types'
import Suggestion from './Suggestion'
import { pick } from 'lodash'

/**
 * Display all suggestions that match the current search.
 */
class SuggestionList extends React.Component {
  static propTypes = {
    copySuggestion: PropTypes.func.isRequired,
    search: PropTypes.arrayOf(PropTypes.string),
    showDiff: PropTypes.bool.isRequired,
    showDetail: PropTypes.func.isRequired,

    suggestions: PropTypes.arrayOf(PropTypes.shape({
      // true when the translation has just been copied
      copying: PropTypes.bool.isRequired,
      suggestion: PropTypes.shape({
        matchDetails: PropTypes.arrayOf(PropTypes.shape({
          type: PropTypes.string.isRequired,
          contentState: PropTypes.string
        })),
        similarityPercent: PropTypes.number,
        sourceContents: PropTypes.arrayOf(
          PropTypes.string).isRequired,
        targetContents: PropTypes.arrayOf(
          PropTypes.string).isRequired
      })
    }))
  }

  render () {
    const sharedProps = pick(this.props,
      ['copySuggestion', 'search', 'showDiff', 'showDetail'])

    const suggestions = this.props.suggestions.map((suggestion, index) => {
      return <Suggestion key={index}
        index={index}
        suggestion={suggestion}
        {...sharedProps} />
    })

    return (
      <div>
        {suggestions}
      </div>
    )
  }
}

export default SuggestionList



// WEBPACK FOOTER //
// ./app/editor/components/SuggestionList.js